import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AppLayout from "@/pages/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Services from "@/pages/Services";
import Employees from "@/pages/Employees";
import Dealerships from "@/pages/Dealerships";
import Signatures from "@/pages/Signatures";
import Customize from "@/pages/Customize";
import Estimates from "@/pages/Estimates";
import "@/App.css";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-zinc-500 label-caps">Loading…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-zinc-500 label-caps">Loading…</div>;
  if (user) return <Navigate to="/app/dashboard" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
          <Route path="/app" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="services" element={<Services />} />
            <Route path="employees" element={<Employees />} />
            <Route path="dealerships" element={<Dealerships />} />
            <Route path="signatures" element={<Signatures />} />
            <Route path="estimates" element={<Estimates />} />
            <Route path="customize" element={<Customize />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
